/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS, displayYesOrNull } from '../utilities';
import './styles.scss';
import { Unit, checkIfValueIsValid, formatValue } from '../common';

export const getInsuranceData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.INSURANCE;

  const insuranceData = dataSet[factKey];

  const InsuranceFactsRow = ({ facts }) => {
    const krFields = ['amount'];

    const factFieldName = facts?.factFieldName;
    if (checkIfValueIsValid(facts?.value)) {
      return (
        <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
          <div className='object-listing-accordian-list-left'>
            {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
              objectText?.[factKey]?.[factFieldName]?.label ||
              facts?.factFieldName}
          </div>
          <div className='object-listing-accordian-list-right'>
            {formatValue(facts, krFields)}{' '}
            <Unit krFields={krFields} facts={facts} />
          </div>
        </div>
      );
    }

    return <></>;
  };

  const InsuranceSection = () => {
    return (
      <div className='insurance-data-body'>
        <InsuranceFactsRow
          key='amount'
          facts={{
            factFieldName: 'amount',
            value: insuranceData?.amount
          }}
        />
        <InsuranceFactsRow
          key='company'
          facts={{
            factFieldName: 'company',
            value: insuranceData?.company
          }}
        />
        <InsuranceFactsRow
          key='fullValue'
          facts={{
            factFieldName: 'fullValue',
            value: displayYesOrNull(insuranceData?.fullValue)
          }}
        />
      </div>
    );
  };

  return {
    component: <InsuranceSection />,
    factsCount: 0
  };
};
